import * as Yup from 'yup';

export const forgotPasswordValidate = Yup.object().shape({
  email: Yup.string()      
            .email('Invalid email format')
            .required('Email is required')
})